import AGREGAR_CONTRATO_CONVENIO_MODIFICATORIO from '@/graphql/mutations/administracion/contratos/contrato/convenios/agregarContratoConvenio.gql';
import REMOVER_CONTRATO_CONVENIO_MODIFICATORIO from '@/graphql/mutations/administracion/contratos/contrato/convenios/removerContratoConvenioModificatorio.gql';
import CONTRATO_CONVENIOS_MODIFICATORIOS from '@/graphql/querys/administracion/contratos/contrato/convenios.gql';
import ACTUALIZAR_CONTRATO_CONVENIO_MODIFICATORIO from '@/graphql/mutations/administracion/contratos/contrato/convenios/actualizarContratoConvenioModificatorio.gql';

export default {
  methods: {
    async mixAgregarConvenio() {
      this.enviandoFormulario = true;
      this.mixEsCargando();
      const { contratoConvenioModificatorio } = this;
      const idContrato = this.contrato.id;
      contratoConvenioModificatorio.idContrato = idContrato;
      if (contratoConvenioModificatorio.tipo === 'MONTO - REDUCCIÓN') {
        contratoConvenioModificatorio.importeCostoDirecto *= -1;
        contratoConvenioModificatorio.importeCostoIndirectos *= -1;
        contratoConvenioModificatorio.importeUtilidad *= -1;
        contratoConvenioModificatorio.importeCargosAdicionales *= -1;
        contratoConvenioModificatorio.importeCostoFinanciero *= -1;
        contratoConvenioModificatorio.importe *= -1;
        contratoConvenioModificatorio.iva *= -1;
        contratoConvenioModificatorio.total *= -1;
      }
      await this.$apollo
        .mutate({
          mutation: AGREGAR_CONTRATO_CONVENIO_MODIFICATORIO,
          variables: { contratoConvenioModificatorio },
          update: (store, { data: { agregarContratoConvenioModificatorio } }) => {
            const query = {
              query: CONTRATO_CONVENIOS_MODIFICATORIOS,
              variables: { idContrato },
            };
            const { contratoConveniosModificatorios } = store.readQuery(query);
            const contratoConveniosModificatoriosCopia = contratoConveniosModificatorios.slice();
            contratoConveniosModificatoriosCopia.push(agregarContratoConvenioModificatorio);
            store.writeQuery({
              ...query,
              data: {
                contratoConveniosModificatorios: contratoConveniosModificatoriosCopia,
              },
            });
          },
        }).then(() => {
          this.mixMensajeSuccess();
        }).catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixActualizarConvenioModificatorio() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      const { contratoConvenioModificatorio } = this;
      if (contratoConvenioModificatorio.tipo === 'MONTO - REDUCCIÓN') {
        contratoConvenioModificatorio.importeCostoDirecto *= -1;
        contratoConvenioModificatorio.importeCostoIndirectos *= -1;
        contratoConvenioModificatorio.importeUtilidad *= -1;
        contratoConvenioModificatorio.importeCargosAdicionales *= -1;
        contratoConvenioModificatorio.importeCostoFinanciero *= -1;
        contratoConvenioModificatorio.importe *= -1;
        contratoConvenioModificatorio.iva *= -1;
        contratoConvenioModificatorio.total *= -1;
      }
      await this.$apollo.mutate({
        mutation: ACTUALIZAR_CONTRATO_CONVENIO_MODIFICATORIO,
        variables: {
          id: this.convenioModificatorioEditar.id,
          contratoConvenioModificatorio,
        },
        update: (store, { data: { actualizarContratoConvenioModificatorio } }) => {
          const query = {
            query: CONTRATO_CONVENIOS_MODIFICATORIOS,
            variables: {
              idContrato: this.convenioModificatorioEditar.idContrato,
            },
          };
          const data = store.readQuery(query);
          const { contratoConveniosModificatorios } = data;
          const index = contratoConveniosModificatorios
            .findIndex((convenioModificatorio) => convenioModificatorio.id
            === actualizarContratoConvenioModificatorio.id);
          if (index !== -1) {
            contratoConveniosModificatorios
              .splice(index, 1, actualizarContratoConvenioModificatorio);
          }
          store.writeQuery({ ...query, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixEliminarConvenioModificatorio() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_CONTRATO_CONVENIO_MODIFICATORIO,
        variables: {
          id: this.convenioModificatorioEliminar.id,
        },
        update: (store) => {
          const query = {
            query: CONTRATO_CONVENIOS_MODIFICATORIOS,
            variables: {
              idContrato: this.convenioModificatorioEliminar.idContrato,
            },
          };
          const data = store.readQuery(query);
          const { contratoConveniosModificatorios } = data;
          const index = contratoConveniosModificatorios
            .findIndex((convenio) => convenio.id === this.convenioModificatorioEliminar.id);
          if (index !== -1) {
            contratoConveniosModificatorios.splice(index, 1);
          }
          store.writeQuery({ ...query, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    calcularCostosDeFinanciamiento() {
      const {
        porcentajeCostoIndirectos,
        porcentajeUtilidad,
        porcentajeCargosAdicionales,
      } = this.contrato;

      const { importeCostoDirecto } = this.contratoConvenioModificatorio;

      this.contratoConvenioModificatorio.importeCostoIndirectos = (
        (porcentajeCostoIndirectos / 100) * importeCostoDirecto);

      this.contratoConvenioModificatorio.importeUtilidad = (
        (this.contratoConvenioModificatorio.importeCostoIndirectos + importeCostoDirecto)
          * (porcentajeUtilidad / 100)
      );

      this.contratoConvenioModificatorio.importeCargosAdicionales = (
        (this.contratoConvenioModificatorio.importeCostoIndirectos
          + this.contratoConvenioModificatorio.importeUtilidad
          + importeCostoDirecto) * (porcentajeCargosAdicionales / 100));

      this.sumarImportesFinanciado();
    },
    calcularTotalPorTipo() {
      if (this.contrato.esObraFinanciada) {
        const {
          porcentajeCostoIndirectos,
          porcentajeUtilidad,
          porcentajeCargosAdicionales,
        } = this.contrato;
        const { importe } = this.contratoConvenioModificatorio;
        const importeAdicionales = (importe / ((porcentajeCargosAdicionales / 100) + 1));
        const importeUtilidad = (importeAdicionales / ((porcentajeUtilidad / 100) + 1));
        const importeIndirectos = (importeUtilidad / ((porcentajeCostoIndirectos / 100) + 1));

        this.contratoConvenioModificatorio.importeCostoDirecto = importeIndirectos;
        this.calcularCostosDeFinanciamiento();
      } else {
        this.calcularTotal();
      }
    },
    sumarImportesFinanciado() {
      const {
        importeCostoDirecto,
        importeCostoIndirectos,
        importeUtilidad,
        importeCargosAdicionales,
        importeCostoFinanciero,
      } = this.contratoConvenioModificatorio;
      this.contratoConvenioModificatorio.importe = this.$numberRound(
        (importeCostoDirecto
          + importeCostoIndirectos
          + importeUtilidad
          + importeCargosAdicionales
          + importeCostoFinanciero
        ),
      );

      this.calcularTotal();
    },
    calcularTotal() {
      const { importe } = this.contratoConvenioModificatorio;
      if (importe === 0) return;

      const numImporte = Number(importe);
      const importeIVA = this.$numberRound(numImporte * (this.porcentajeIvaContrato / 100));
      const total = this.$numberRound((numImporte + importeIVA));

      this.contratoConvenioModificatorio.iva = importeIVA;
      this.contratoConvenioModificatorio.total = total;
    },
  },
  computed: {
    isPlazo() {
      const { tipo } = this.contratoConvenioModificatorio;
      return tipo === 'PLAZO'
        || tipo === 'REPROGRAMACIÓN'
        || tipo === 'FINANCIERO'
        || tipo === 'PLAZO - MONTO AMPLIACIÓN';
    },
    isMeta() {
      return this.contratoConvenioModificatorio.tipo === 'CAMBIO DE META';
    },
    isMonto() {
      const { tipo } = this.contratoConvenioModificatorio;
      if (!tipo) return false;
      return tipo.substr(0, 5) === 'MONTO'
      || tipo === 'PLAZO - MONTO AMPLIACIÓN';
    },
    porcentajeIvaContrato() {
      if (!this.contrato) return 0;
      return this.contrato.porcentajeIva;
    },
  },
};
